export default class Header {
  constructor(elem, APP) {
    this.elem = elem;
  }

  init() {}
}
